/* eslint-disable no-use-before-define */
import React from 'react'
import { Formik, } from 'formik'
import { Form } from './accounts/form'
import { arrayFrom, cleanObject, isEmpty, isEquals, publish } from '../twd/twd'
import { ErrorBoundary } from './error-boundary'
import { allAccounts, useOrders } from './use-orders'

export const Accounts = () => {

    const { accounts, setAccounts, setAccountsRef } = useOrders()

    return <ErrorBoundary>
        <Formik
            ref={setAccountsRef}

            initialValues={{
                accounts: [...(isEmpty(accounts) ? allAccounts() : accounts)],
            }}
            enableReinitialize={true}

            onSubmit={(values) => {
                const curr = isEmpty(accounts) ? allAccounts() : accounts.sort()
                const accts = arrayFrom(values.accounts).sort()
                if (isEquals(accts, curr)) return
                setAccounts(accts)
            }}

            component={Form}
            validateOnBlur={true}
            validateOnChange={true}
            validate={(values) => {
                const accounts = arrayFrom(values.accounts)
                const errors = cleanObject({
                    accounts: accounts.length > 0
                        ? null
                        : 'Please select at least 1 account'
                })

                publish('orders_accounts_changed', {accounts})
                return errors
            }}
        />
    </ErrorBoundary>
}
